document.addEventListener('DOMContentLoaded', () => {
  const swiperEl = document.querySelector('.grid-icons-swiper');
  if (!swiperEl) return;

  new Swiper(swiperEl, {
    slidesPerView: 1.8,
    spaceBetween: 24,
    freeMode: true,
    mousewheel: { forceToAxis: true },
    pagination: {
      el: '.grid-icons__progress',
      type: 'progressbar',
    },
    breakpoints: {
      990: {
        slidesPerView: 'auto',
        spaceBetween: 72,
      },
    },
  });
});
